import { UploadDocumentTemplatesFileData } from "@interfaces/company/document-templates";
import { documentTemplateService } from "@services/document-templates-service";
import { useMutation, useQueryClient } from "react-query";
import { documentTemplatesQueryKeys } from "./queryKeys";

export const useUploadDocumentTemplateFilesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: UploadDocumentTemplatesFileData) =>
      documentTemplateService.addFiles(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
